import './footer.scss';
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../LocalizedLink';


const Footer = () => {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return (
        <div className='footerContainer'>
            <nav className='footerNav'>
                <LocalizedLink to="/ours">{t('nav.ours')}</LocalizedLink>
                <LocalizedLink to="/howHelp">{t('nav.howHelp')}</LocalizedLink>
                <LocalizedLink to="/contact">{t('nav.contact')}</LocalizedLink>
                <LocalizedLink to="/blog">{t('nav.blog')}</LocalizedLink>
            </nav>
            <div className='footerBottom'>
                <span>© {year} {t('footer.orgName')}. {t('footer.allRightsReserved')} {t('footer.developedBy')}.</span>
                <LocalizedLink to="/policy" className='footerPolicyLink'>{t('footer.privacyPolicy')}</LocalizedLink>
            </div>
        </div>
    );
}

export default Footer;
